import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

/**
 * Keeps selectedMode in sync with the current route so staging bookmark URLs work.
 */
const ModeFromUrlSync = () => {
  const { pathname, search } = useLocation();
  const { syncModeFromUrl } = useAuth();

  useLayoutEffect(() => {
    syncModeFromUrl(pathname, search);
  }, [pathname, search, syncModeFromUrl]);

  return null;
};

export default ModeFromUrlSync;
